import { useContext, useState } from "react";
import {
  GET_CUSTOMDATAREPORT,
  GET_DATAREPORTS
} from "../../../Querys/reports/querys";
import { useLazyQuery } from "@apollo/client";
import ReportContext from "../../../context/ReportsContext/ReportContext";
import { useHistory } from 'react-router-dom';
import { editReportsModal, deleteReportsModal } from "../../../context/ReportsContext/Actions"
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import TablePagination from '@mui/material/TablePagination'; // <- import paginación
import moment from "moment-timezone"
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import CreateIcon from '@mui/icons-material/Create';
import DownExcel from "../../../assets/icons/downExcel.svg";
import { DownloadExcel } from "../../../helpers/DownloadExcel";

import { renamePropertiesSpanish } from "../../../helpers/renamePropertiesSpanish";
import { AdminContext } from "../../../context/AdminContext/AdminContext";

const TableReport = ({ reports }: any) => {
  const { adminState } = useContext(AdminContext);
  const { dispatch } = useContext(ReportContext)
  const history = useHistory();
  const [getReportSingle] = useLazyQuery(GET_DATAREPORTS);
  const [getCustomReportSingle] = useLazyQuery(GET_CUSTOMDATAREPORT);

  // Estados para paginación
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5); // puedes cambiar por default

  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleEliminar = (id: any, reportType: any = null) => {
    const tipo = reportType === "Personalizado" ? "Personalizado" : reportType
    deleteReportsModal(id, true, tipo ,dispatch)
  }

  const handleEditReportPredefined = (id: any) => {
    editReportsModal(id, true, dispatch)
  }

  const handleEditReport = (id: any, reportType: any = null) => {
   if (reportType === "Personalizado") {
      history.push(`/informes/custom-${id}`)
    } 
    else {
      history.push(`/informes/${id}`)
    }
  }

  const handleDownloadReport = async (id: any) => {
    let reportById = reports.filter((report: any) => report.id === id);

    if (reportById[0]?.ReportType === "Personalizado") {
      let { data } = await getCustomReportSingle({ variables: { getDatareportsId: id } });
      if (data?.GET_CUSTOMDATAREPORT?.length > 0) {
        const reportJson = JSON.parse(data.GET_CUSTOMDATAREPORT);
        const columns = reportJson?.query.map((re: any) => Object.keys(re));
        const valuesRep = reportJson?.query.map((data: any) => Object.values(data));
        DownloadExcel(reportById[0]?.ReportName, reportById[0]?.ReportName, columns[0], valuesRep);
      }
    } else {
      let { data } = await getReportSingle({ variables: { getDatareportsId: id } });
      if (data?.GET_DATAREPORTS?.length > 0) {
        const reportJson = renamePropertiesSpanish(JSON.parse(data.GET_DATAREPORTS));
        const columns = reportJson.map((re: any) => Object.keys(re));
        const valuesRep = reportJson.map((data: any) => Object.values(data));
        DownloadExcel(reportById[0]?.ReportName, reportById[0]?.ReportName, columns[0], valuesRep);
      }
    }
  }

  return (
    <Paper>
      <TableContainer>
        <Table sx={{ minWidth: 650 }} aria-label="caption table">
          <TableHead>
            <TableRow className='pd_contenedorTitulos'>
              <TableCell className='cellSpanTitleReport' align="left">Tipo de Informe</TableCell>
              <TableCell className='cellSpanTitleReportName' align="left">Nombre</TableCell>
              <TableCell className='cellSpanTitleReportDes' align="left">Descripción</TableCell>
              <TableCell className='cellSpanTitleReport' align="left">Fecha de creación</TableCell>
              <TableCell className='cellSpanTitleButonns' align="left"></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {reports
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((report: any) => (
              <TableRow key={`${report.id}${report.ReportType}`}>
                <TableCell component="th" scope="row">{report.ReportType}</TableCell>
                <TableCell align="left">{report.ReportName}</TableCell>
                <TableCell align="left">{report.ReportDescription}</TableCell>
                <TableCell align="left">{moment(report.ReportDate).format("DD/MM/YYYY")}</TableCell>
                <TableCell align="left">
                  <div className='containerIcons'>
                    {report.userAdd !== null && (report.ReportType === 'Personalizado' || adminState?.Usuario === report.userAdd ) ?
                      <>
                        <DeleteOutlineIcon
                          className='deleteReport'
                          sx={{ color: '#E0544B' }}
                          onClick={() => handleEliminar(report.id, report.ReportType)}
                        />
                        <CreateIcon
                          className='editReport'
                          sx={{ color: '#093C5D' }}
                          onClick={() => handleEditReport(report.id, report.ReportType)}
                        />
                      </>
                      :
                      <>
                        <DeleteOutlineIcon color="disabled" />
                        <CreateIcon
                          className='editReport'
                          sx={{ color: '#093C5D' }}
                          onClick={() => handleEditReportPredefined(report.id)}
                        />
                      </>
                    }
                    <img
                      className='downExcelReport'
                      src={DownExcel} alt="descargar excel"
                      onClick={() => handleDownloadReport(report.id)}
                    />
                  </div>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      {/* Paginación en español */}
      <TablePagination
        rowsPerPageOptions={[5, 10, 25]}
        component="div"
        count={reports.length}
        rowsPerPage={rowsPerPage}
        page={page}
        labelRowsPerPage="Filas por página"
        labelDisplayedRows={({ from, to, count }) => `${from}-${to} de ${count}`}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </Paper>
  )
}

export default TableReport;
